import { render, staticRenderFns } from "./UserUserGroupDeleteModal.vue?vue&type=template&id=1a44ff77&scoped=true&"
import script from "./UserUserGroupDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./UserUserGroupDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a44ff77",
  null
  
)

export default component.exports